import React from 'react';
import { Spacer } from '@cleartrip/bento';

function Podcast({ title, description, imgUrl, audioLink, date, episode, ...otherProps }) {
	return (
		<>
			<div className='flex flex-top' {...otherProps}>
				<div>
					<img src={imgUrl} className='of-cover br-100 bg-neutral-0 d-none--xs' width={60} height={60} />
					<img src={imgUrl} className='of-cover br-100 bg-neutral-0 d-none d-block--xs' width={40} height={40} />
				</div>
				<Spacer className='pr-4' />
				<div>
					<div className='fs-7 c-neutral-900 fw-600'>
						{episode}.&nbsp;{title}
					</div>
					<Spacer className='pt-2' />
					<div className='fs-3 c-neutral-400'>{date}</div>
				</div>
			</div>
			<Spacer className='pt-4' />
			<p className='lh-copy fs-4 c-neutral-700'>{description}</p>
			<Spacer className='pt-7' />
			<audio className='w-100p' controls>
				<source src={audioLink} type='audio/mp3' />
			</audio>
		</>
	);
}

export default Podcast;
